import React from 'react';
import "./styles/Header.scss";
import HeaderSearchBoxContainer from "components/Header/components/HeaderSearchBox/container";
import HeaderSearchButtonContainer from "components/Header/components/HeaderSearchButton/container";
import HeaderBurgerButtonContainer from "components/Header/components/HeaderBurgerButton/container";
import HeaderMainMenuContainer from "components/Header/components/HeaderMainMenu/container";
import HeaderLogo from "components/Header/components/HeaderLogo";
import classNames from 'classnames';

const Header = (props) => {
  const isHomePage = window.location.pathname === "/";

  return (
    <header className={classNames({
      "proquinal-header fixed-top": true,
      "proquinal-header-user-info__space": !isHomePage,
    })}>
      <section className="proquinal-header__content">
        <div className="container">
          <div className="row no-gutters">
            <div className={classNames(
              "proquinal-header-col proquinal-header-col--main-menu col-lg-10 order-lg-2",
              !isHomePage ? "col" : "col-1"
            )}>
              <HeaderBurgerButtonContainer/>
              <HeaderMainMenuContainer/>
            </div>
            <div className={classNames(
              "proquinal-header-col proquinal-header-col--logo col-lg-2 col-xl-auto order-lg-0",
              !isHomePage ? "col" : "col-11"
            )}>
              <HeaderLogo/>
            </div>
            <div className={classNames({
              "proquinal-header-col proquinal-header-col--search-button col order-lg-1": true,
              "d-none": isHomePage
            })}>
              <HeaderSearchButtonContainer/>
            </div>
          </div>
        </div>
      </section>
      <HeaderSearchBoxContainer/>
    </header>
  )
};

export default Header;